module.exports = __webpack_public_path__ + "img/consumption-pool.833ae3de.svg";